import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import GlobalProvider from './context/GlobalProvider';
import NavbarNew from './layout/NavbarNew';
import Home from './page/Home';
import About from './page/About';
import ContactUs from './page/ContactUs';
import Settings from './page/Settings';
import Register from './login/Register';
import Login from './login/Login';
import Logout from './login/Logout';
import Dashboard from './page/Dashboard';
import Archive from './page/Archive';
import ForgetPassword from './login/ForgetPassword';
import ResetPassword from './login/ResetPassword';
// import Prices from './components/prices/Prices';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <GlobalProvider>
        <BrowserRouter>
        <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={true}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
                style={{ zIndex: 10000 }}
            />
          <NavbarNew />
          <div className="min-h-screen flex flex-col">
            <main className="flex-grow" >
              <>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/archive" element={<Archive />} />
                  {/* <Route path="/prices" element={<Prices />} /> */}
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<ContactUs />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/logout" element={<Logout />} />
                  <Route path="*" element={<Login />} />
                  <Route path="/forgotPassword" element={<ForgetPassword />} />
                  <Route path="resetPassword/:userid/:token" element={<ResetPassword />} />
                  <Route path="/register" element={<Register />} />
                </Routes>
              </>
            </main>
            <footer className="w-full text-3xl text-gray-600 bg-gray-100 border-t border-gray-300 py-4 text-center">
              <small>eBhasha Setu Language Services Pvt Ltd. {new Date().getFullYear()} | All Rights Reserved</small>
            </footer>
          </div>
        </BrowserRouter>
      </GlobalProvider>
    </>
  );
}

export default App;
